import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets.app/images/18514_hero.svg'


const _hoisted_1 = { class: "cancel-flow-pause-feature" }
const _hoisted_2 = { class: "cancel-flow-pause-feature__feedback" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "cancel-flow-popup__footer" }

import { onMounted } from 'vue'

import AppButton from '@/app/components/button/AppButton.vue'
import { BillingView } from '@/models/billing'
import type { ReasonValue } from '@/models/billing.cancelFlow'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelFlowPauseFeature',
  props: {
    billing: {},
    canceling: { type: Boolean },
    reason: {}
  },
  emits: ["feedback", "continueCancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

onMounted(() => {
  Mixpanel.trackCancelFlowStepShown(props.billing, 'feature', props.reason)
})

function onFeedback(value: 'interested' | 'not_interested'): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'feature',
    value,
    props.reason,
  )
  emit('feedback', value)
}

function onEndMembership(): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'feature',
    'end_membership',
    props.reason,
  )
  emit('continueCancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("img", {
        class: "cancel-flow-pause-feature__image",
        src: _imports_0,
        width: "415",
        height: "240",
        alt: ""
      }, null, -1)),
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "cancel-flow-pause-feature__title" }, " Are you interested in pausing your subscription? ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "cancel-flow-pause-feature__feedback-btn",
          "aria-label": "Not interested",
          disabled: __props.canceling,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onFeedback('not_interested')))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "iconfont idislike" }, null, -1)
        ]))], 8, _hoisted_3),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "cancel-flow-pause-feature__feedback-divider" }, null, -1)),
        _createElementVNode("button", {
          class: "cancel-flow-pause-feature__feedback-btn",
          "aria-label": "Interested",
          disabled: __props.canceling,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onFeedback('interested')))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "iconfont ilike" }, null, -1)
        ]))], 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(AppButton, {
        danger: true,
        loading: __props.canceling,
        disabled: __props.canceling,
        class: "cancel-flow-popup__cta",
        onClick: onEndMembership
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode(" End my membership ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ], 64))
}
}

})